import { put, takeEvery } from 'redux-saga/effects';

// Actions
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';

// Reducer
export default function notificationsReducer(state = { data: [], count: 0 }, action) {
  const { type, payload } = action;
  switch (type) {
    case ADD_NOTIFICATION: {
      const notificationIndex = state.data.findIndex(item => (
        item.message === payload.message && item.variant === payload.variant
      ));
      if (notificationIndex !== -1) {
        return state;
      }
      return {
        data: [
          ...state.data,
          {
            variant: 'default',
            id: new Date().getTime(),
            ...payload,
          },
        ],
        count: state.count + 1,
      };
    }
    case REMOVE_NOTIFICATION:
      return {
        data: [
          ...state.data.slice(1),
        ],
        count: state.count - 1,
      };
    default:
      return state;
  }
}

// Action Creators
export function addNotification(payload) {
  return { type: ADD_NOTIFICATION, payload };
}

export function removeNotification() {
  return { type: REMOVE_NOTIFICATION };
}

function* notificationsErrorsInterceptionSaga(action) {
  const { payload } = action;
  let message = 'Server failed with exception, please, inform developers';
  if (payload === 'TypeError: Failed to fetch'
    || (payload.error && payload.error === 'TypeError: Failed to fetch')) {
    message = 'Network error occurred, please, check your connection';
  }
  yield put(addNotification({
    message,
    variant: 'warning',
  }));
}

export function* notificationsSaga() {
  yield takeEvery(action =>
    (action.type.indexOf('FAIL') !== -1)
      && action.payload
      && ((!action.payload.error && action.payload === 'TypeError: Failed to fetch')
      || (!action.payload.error
        && typeof action.payload === 'string'
        && action.payload.indexOf('Server fail with exception') !== -1)
      || (!action.payload.error
        && typeof action.payload === 'string'
        && action.payload.indexOf('Traceback (most recent call last)') !== -1)
      || (action.payload.error && action.payload.error === 'TypeError: Failed to fetch')
      || (action.payload.error && action.payload.error.indexOf('Server fail with exception') !== -1)
      || (action.payload.error && action.payload.error.indexOf('Traceback (most recent call last)') !== -1)),
  notificationsErrorsInterceptionSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/notifications.js